import React, {useEffect} from "react";
import style from "../../../assets/scss/sub/consultantHistory.module.scss";
import AddConsultationModal from "../../common/modal/consultation/AddConsultationModal";
import ConfirmConsultantModal from "../../common/modal/ConfirmConsultantModal";
import EditConsultationModal from "../../common/modal/consultation/EditConsultationModal";
import AboutConsultantModal from "../../common/modal/AboutConsultantModal";
import {ReviewConsultantModal} from "../../common/modal/consultation/ReviewConsultantModal";
import {useConsultationGetter} from "./hooks/useConsultationGetter";
import {useConsultationPagination} from "./hooks/useConsultationPagination";
import {ConsultantHistoryColumns} from "./hooks/ConsultantHistoryColumns";
import {useConsultationModals} from "./hooks/ConsultationModalProvider";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

interface ProfileInfo {
    idx: number;
    name: string;
    birthday: string;
    createAt: string;
    userCode: string;
    testCnt: number;
    isOwnerProfile: boolean;
}

interface ProfileInfoProps {
    profileIdx: number;
    profileInfo: ProfileInfo;
}

export function ConsultationHistory({profileIdx, profileInfo}: ProfileInfoProps) {
    const { t } = useTranslation("consultant");
    const {getTestHistory, consultationHistory} = useConsultationGetter();
    const {currentPage, handlePageChange} = useConsultationPagination({
        totalElements: consultationHistory?.totalElements ?? 0
    });

    const {modalStates, modalActions} = useConsultationModals();
    const navigate = useNavigate();

    const onRefresh = () => {
        getTestHistory({profileIdx: profileIdx, currentPage: currentPage}).then();
        // window.location.reload();
    }

    useEffect(() => {
        if (profileIdx === null) return;
        getTestHistory({profileIdx: profileIdx, currentPage: currentPage}).then();
    }, [getTestHistory, currentPage, profileIdx]);

    return (
        <div className={style.container}>
            <div className={style.containerContentBox} style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                <h2 className={style.containerTitle}>
                    {t('detail.title')}&nbsp;
                    <span className={style.profileCount}>({profileInfo?.name ? profileInfo?.name : "나"}</span>
                    <span className={style.profileCount}>)</span>
                </h2>
                {/* 상담/기관 찾기 신규 화면 진입 버튼 (시안 페이지) */}
                <button
                    onClick={() => navigate("/mypage/consultation")}
                    style={{
                        padding: "8px 14px", borderRadius: 8, border: "none",
                        background: "#6630ff", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer",
                    }}
                >
                    상담 / 기관 찾기 →
                </button>
            </div>

            <ConsultantHistoryColumns
                consultationHistory={consultationHistory}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
            />

            <EditConsultationModal
                isOpen={modalStates.isEditModal}
                selectedConsultation={modalStates.selectedConsultation}
                onRefresh={onRefresh}
                onClose={modalActions.removeToggle}/>

            <ConfirmConsultantModal
                isOpen={modalStates.isConfirmModal}
                onClose={modalActions.removeToggle}
                selectedConsultation={modalStates.selectedConsultation}
                profileName={profileInfo?.name}
            />

            <AddConsultationModal isOpen={modalStates.isCounselingReserve}
                                  selectedConsultation={modalStates.selectedConsultation}
                                  onRefresh={onRefresh}
                                  onClose={() => modalActions.toggleReserveModal(null)}
            />

            <AboutConsultantModal
                isOpen={modalStates.isConsultantModal}
                selectedConsultation={modalStates.selectedConsultation}
                onClose={modalActions.removeToggle}
            />

            <ReviewConsultantModal
                isOpen={modalStates.isReviewModal}
                selectedConsultation={modalStates.selectedConsultation}
                onClose={modalActions.removeToggle}
                onRefresh={onRefresh}
            />
        </div>
    );
}
